import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { activeBrokerLocalStorageKey } from 'reducers/activeBroker';
import { useCustomsBrokerId } from './useCustomsBrokerId';

export const getActiveBrokerId = (): string | null =>
  localStorage.getItem(activeBrokerLocalStorageKey);

export const useActiveBrokerId = (): string | undefined => {
  const currentActiveBroker = useSelector(
    (state: RootState) => state.activeBroker.currentActiveBroker,
  );
  const customsBrokerId = useCustomsBrokerId();
  return getActiveBrokerId() || currentActiveBroker || customsBrokerId;
};
